(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ss-format-link]');
    if (!link) return;
    const url = new URL(link.href);
    const current = new URLSearchParams(window.location.search);
    current.delete('page');
    current.delete('section_id');
    current.delete('sections');
    url.search = current.toString();
    link.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-project-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(){
    const root=document.getElementById('ss-project-inquiry');if(!root||root.dataset.ready)return;root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('.ss-inquiry-data').textContent),details=root.querySelector('.ss-inquiry-details');
    const app=document.querySelector('[id$="__'+root.dataset.appSection+'"]');if(!app)return;app.classList.add('ss-inquiry-app');app.hidden=true;
    const status=root.querySelector('.ss-inquiry-status'),drafts={};let current=null;
    const marker='\n--- Weitere Angaben ---\n';
    function remember(){if(!current)return;drafts[current.key]=[...root.querySelectorAll('[data-topic-field]')].map(e=>e.value);}
    function updateMessage(){
      if(!current)return false;const text=app.querySelector('textarea[name="textarea"]');if(!text)return false;
      const project=app.querySelector('input[name="text-2"]');
      if(project){project.readOnly=true;if(project.value!==current.title){Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(project,current.title);project.dispatchEvent(new Event('input',{bubbles:true}));project.dispatchEvent(new Event('change',{bubbles:true}));}}
      const old=text.value,free=old.includes(marker)?old.slice(old.indexOf(marker)+marker.length):old;
      const rows=['Projektanfrage: '+current.title];
      for(const e of root.querySelectorAll('[data-field],[data-topic-field]'))rows.push((e.dataset.field||e.dataset.label)+': '+(e.value.trim()||'Noch offen'));
      const next=rows.join('\n')+marker+free;
      if(text.value!==next){Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set.call(text,next);text.dispatchEvent(new Event('input',{bubbles:true}));text.dispatchEvent(new Event('change',{bubbles:true}));}
      const heading=app.querySelector('.globo-heading'),headingText=current.title+' – deine Kontaktdaten';if(heading&&heading.textContent!==headingText)heading.textContent=headingText;
      return true;
    }
    function select(key,scroll){
      const item=data.find(x=>x.key===key);if(!item)return;remember();current=item;details.hidden=false;app.hidden=false;root.classList.add('is-selected');
      for(const button of root.querySelectorAll('[data-project]'))button.setAttribute('aria-pressed',String(button.dataset.project===key));
      root.querySelector('#ss-inquiry-title').textContent=item.title+' anfragen';root.querySelector('#ss-inquiry-description').textContent=item.description;
      root.querySelector('#ss-inquiry-subject').textContent='Projektanfrage: '+item.title;
      const labels=item.fields.split('\n');root.querySelectorAll('[data-topic-field]').forEach((e,i)=>{const parts=(labels[i]||'Weitere Details').split('|');e.dataset.label=parts[0];e.closest('label').querySelector('span').textContent=parts[0];e.placeholder=parts[1]||'';e.value=drafts[key]?.[i]||''});
      const url=new URL(location.href);url.searchParams.set('projekt',key);history.replaceState(null,'',url);document.title=item.title+' anfragen | Schneider Solutions';
      updateMessage();if(scroll){details.scrollIntoView({behavior:'instant',block:'start'});root.querySelector('#ss-inquiry-title').focus({preventScroll:true});}
    }
    root.querySelectorAll('[data-project]').forEach(b=>b.addEventListener('click',()=>select(b.dataset.project,true)));
    root.querySelector('.ss-inquiry-change').addEventListener('click',()=>{root.classList.remove('is-selected');root.querySelector('.ss-inquiry-options').scrollIntoView({behavior:'smooth',block:'start'});root.querySelector('[data-project]')?.focus({preventScroll:true});});
    root.querySelector('.ss-inquiry-continue').addEventListener('click',()=>{if(updateMessage()){status.textContent='Deine Projektangaben wurden in die Anfrage übernommen.';app.scrollIntoView({behavior:'instant',block:'start'});app.querySelector('input[name="text-1"]')?.focus({preventScroll:true});}else{status.textContent='Das Kontaktformular wird noch geladen. Bitte versuche es gleich erneut oder schreibe uns an help@schneider-solutions.store.';}});
    root.querySelectorAll('input,select').forEach(e=>e.addEventListener('change',updateMessage));
    app.addEventListener('click',e=>{if(e.target.closest('button'))updateMessage();},true);
    app.addEventListener('submit',()=>updateMessage(),true);
    const initial=new URLSearchParams(location.search).get('projekt');if(initial)select(initial,false);
    const observer=new MutationObserver(()=>{updateMessage();});observer.observe(app,{childList:true,subtree:true});
    updateMessage();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcementbar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var marquee = document.querySelector('.section-marquee-announcement[id^="announcement-"]');
    if (marquee) {
      document.documentElement.style.setProperty('--marquee-height', marquee.offsetHeight + 'px');
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
